"use client";

import { useEffect } from "react";
import { useReviewProjectionStore } from "@/lib/stores/reviewProjection";

export function useReviewProjection() {
  const data = useReviewProjectionStore((state) => state.data);
  const status = useReviewProjectionStore((state) => state.status);
  const error = useReviewProjectionStore((state) => state.error);
  const lastLoadedAt = useReviewProjectionStore((state) => state.lastLoadedAt);
  const lastInvalidatedAt = useReviewProjectionStore((state) => state.lastInvalidatedAt);
  const fetch = useReviewProjectionStore((state) => state.fetch);
  const refresh = useReviewProjectionStore((state) => state.refresh);
  const setProjection = useReviewProjectionStore((state) => state.setData);

  useEffect(() => {
    if ((status === "idle" || status === "error") && !data) {
      void fetch();
    }
  }, [data, fetch, status]);

  useEffect(() => {
    if (!lastInvalidatedAt || status === "loading") return;
    if (lastLoadedAt && lastInvalidatedAt <= lastLoadedAt) return;
    void refresh();
  }, [lastInvalidatedAt, lastLoadedAt, refresh, status]);

  return {
    projection: data,
    status,
    error,
    refresh,
    setProjection,
  };
}
